const HeartbeatStatus = {
  Working: 'working',
  Error: 'error',
  Warning: 'warning'
};

export default HeartbeatStatus